import { React, moment, _ } from 'Imports';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TableSortLabel } from 'MaterialUIComponents';
import * as DateFormatter from '../../../Shared/DateFormatter';
import { VideoEventHistoryExport } from '.././VideoEventHistoryExport';
import { VideoEventHistoryTableResponse, VideoEventResponse } from '$Generated/api';
import { VideoEventService } from '$State/VideoEventFreezerService';
import { useEffect, useState } from 'react';

interface ICourtReporterProps {
    event: VideoEventResponse;
    refreshKey?: number;
}

type SortOrder = 'asc' | 'desc';

const styles = require('./CourtReporter.scss') as {
    container: string;
    tableHeadCell: string;
    tableCell: string;
};

const rowHeaders = [
    {
        label: 'Date/Time',
        id: 'actionDate',
    },
    {
        label: 'Created By',
        id: 'createdByName',
    },
    {
        label: 'Description',
        id: 'actionDescription',
    },
];

export const CourtReporter = (props: ICourtReporterProps) => {
    const { event, refreshKey } = props;

    const [sort, setSort] = useState('actionDate');
    const [sortOrder, setSortOrder] = useState<SortOrder>('desc');
    const [videoEventHistoryTableResults, setVideoEventHistoryTableResults] = useState<VideoEventHistoryTableResponse[]>([]);

    useEffect(() => {
        const fetchData = async () => {
            if (event.id) {
                await VideoEventService.getVideoEventHistoryTable(event.id);
                const freezer = VideoEventService.getState();
                setVideoEventHistoryTableResults(freezer.videoEventHistoryTableResults.data?.data || []);
            }
        };
        fetchData();
    }, [refreshKey]);

    const handleRequestSort = (field: string): void => {
        const isAsc = sort === field && sortOrder === 'asc';
        setSort(field);
        setSortOrder(isAsc ? 'desc' : 'asc');
    };

    const orderedResults = _.orderBy(videoEventHistoryTableResults || [], sort, sortOrder);

    return (
        <div className={styles.container}>
            {orderedResults.length > 0 && (
                <VideoEventHistoryExport
                    data={orderedResults}
                    videoEvent={event}
                    mainContainerStyle={{
                        justifyContent: 'flex-start',
                        marginBottom: '16px',
                        marginTop: '0px',
                    }}
                    exportButtonStyle={{ padding: '0px' }}
                />
            )}

            <TableContainer sx={{ maxHeight: '65vh', overflowX: 'hidden' }}>
                <Table stickyHeader>
                    <TableHead>
                        <TableRow>
                            {rowHeaders.map((head) => {
                                return (
                                    <TableCell
                                        key={head.id}
                                        sortDirection={sort === head.id ? sortOrder : false}
                                        className={styles.tableHeadCell}
                                    >
                                        <TableSortLabel
                                            active={sort === head.id}
                                            direction={sortOrder}
                                            onClick={() => handleRequestSort(head.id)}
                                        >
                                            {head.label}
                                        </TableSortLabel>
                                    </TableCell>
                                );
                            })}
                        </TableRow>
                    </TableHead>
                    {orderedResults.length > 0 && (
                        <TableBody>
                            {orderedResults.map((row: VideoEventHistoryTableResponse, idx: number) => {
                                return (
                                    <TableRow key={idx}>
                                        <TableCell className={styles.tableCell}>
                                            <div>{DateFormatter.dateAndTimezone(moment(row.actionDate))}</div>
                                        </TableCell>
                                        <TableCell className={styles.tableCell}>{row.createdByName}</TableCell>
                                        <TableCell className={styles.tableCell}>{row.actionDescription}</TableCell>
                                    </TableRow>
                                );
                            })}
                        </TableBody>
                    )}
                </Table>
            </TableContainer>
        </div>
    );
};
